import { useQuery } from 'react-query';
import { articleApiClient } from '@api/clients';
import { RelatedArticle } from '@api/api';
import { buildArticleLink } from '@utils/link';
import { IRelatedArticleItem } from '@components/article/RelatedArticles/RelatedArticles.types';

export const fetchRelatedArticles = async (
  articleId: string,
  limit = 2,
): Promise<Array<RelatedArticle>> => {
  const { data } = await articleApiClient.articlesIdRelatedGet({ id: articleId, limit });

  return data;
};

export const useRelatedArticles = (articleId: string, limit = 2) => {
  return useQuery(['related-articles', articleId], () => fetchRelatedArticles(articleId, limit), {
    select: (data): IRelatedArticleItem[] => {
      return data.map((relatedArticle) => ({
        article: relatedArticle,
        href: buildArticleLink(String(relatedArticle.id), relatedArticle.slug),
      }));
    },
  });
};

export const fetchNewRelatedArticles = async (
  articleId: string,
): Promise<Array<RelatedArticle>> => {
  const { data } = await articleApiClient.articlesIdNewrelatedGet({ id: articleId });
  return data;
};

export const useNewRelatedArticles = (articleId: string) => {
  return useQuery(['new-related-articles', articleId], () => fetchNewRelatedArticles(articleId), {
    select: (data): IRelatedArticleItem[] => {
      return data.map((relatedArticle) => ({
        article: relatedArticle,
        href: buildArticleLink(String(relatedArticle.id), relatedArticle.slug),
      }));
    },
  });
};
